import DOMPurify from 'dompurify';
import { useTranslation } from 'react-i18next';
import { getIntervals } from '../../constants/options';
import { formatDateForReport } from '../../helpers/formatDate';
import { intervalText } from '../../utils/taskUtils';
import styles from './styles.module.css';

/**
 * TaskDescription component - Displays task description and interval information
 */
export default function TaskDescription({ taskData, descHtml }) {
  const { t } = useTranslation();
  const intervals = getIntervals(t);

  if (!taskData) return null;

  return (
    <div className={styles.description}>
      {taskData.maintenanceName !== 'Report a repair' && (
        <p className={styles.description_title}>
          {intervalText(taskData.intervalType, taskData.intervalValue, intervals)}
          {t('calendar.dayInterval')}
          {formatDateForReport(taskData.createdAt, 'date')}
        </p>
      )}
      <p className={styles.description_task}>{t('modals.taskDescription')}</p>
      {taskData.maintenanceName === 'Report a repair' ? (
        <p className={styles.description_task__desc}>{t('modals.pleaseProvide')}</p>
      ) : (
        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(descHtml) }} />
      )}
    </div>
  );
}
